module.exports = __webpack_public_path__ + "img/Frame.e8d2afac.svg";